import { PermissionRoleExplanation } from '@cs-cms/ui';

const contentTypeAccess =
  'Can access all documents matching the specified content type: Company Code + Billing Application + Business Area.';

const businessAdminApprovers = [
  'Business Admin (except Lock/Unlock role)',
  'Data Owner (for Lock/Unlock role, in case of Business Admin absence)'
];

export const permissionRoleExplanations: PermissionRoleExplanation[] = [
  {
    role: 'Data Owner',
    permissions: [
      'Can access all documents associated with a specific company code.',
      'Can lock or unlock documents to prevent or allow deletion.'
    ],
    approvers: ['Data Owner']
  },
  {
    role: 'Business Admin',
    permissions: [
      contentTypeAccess,
      'The "Business Admin Access with Lock" role can lock or unlock documents to prevent or allow deletion.'
    ],
    approvers: businessAdminApprovers
  },
  {
    role: 'User (Read Access)',
    permissions: [
      contentTypeAccess,
      'The "Read Access with Lock" role can lock or unlock documents to prevent or allow deletion.'
    ],
    approvers: businessAdminApprovers
  },
  {
    role: 'Creator',
    permissions: [
      contentTypeAccess,
      'Can upload documents directly through the GEAR UI in exceptional cases.'
    ],
    approvers: ['Data Owner']
  }
];
